import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RequestStatus } from "common/enums/requestStatus";
import IProject from "common/interfaces/IProject";
import { fetch } from "core/Api";

interface IProjectsState {
  createdProjects: IProject[];
  joinedProjects: IProject[];
  selected: IProject | null;
  status: RequestStatus;
  error: any;
}

const initialState: IProjectsState = {
  createdProjects: [],
  joinedProjects: [],
  selected: null,
  status: RequestStatus.IDLE,
  error: null,
};

export const fetchProjectsByOwnerId = createAsyncThunk(
  "projects/byOwner",
  async (id: string) => {
    try {
      const data = await fetch(`/projects/owner/${id}`);
      return data;
    } catch (e: any) {
      return console.error(e.message);
    }
  }
);

export const fetchProjectsByMemberId = createAsyncThunk(
  "projects/byMember",
  async (id: string) => {
    try {
      const data = await fetch(`/projects/member/${id}`);
      return data;
    } catch (e: any) {
      return console.error(e.message);
    }
  }
);

export const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    resetProjects: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProjectsByOwnerId.pending, (state, action) => {
      state.status = RequestStatus.PENDING;
    });
    builder.addCase(fetchProjectsByOwnerId.fulfilled, (state, action) => {
      state.status = RequestStatus.SUCCEEDED;
      // remove the type any when the api is ready
      state.createdProjects = action.payload as any;
    });
    builder.addCase(fetchProjectsByOwnerId.rejected, (state, action) => {
      state.status = RequestStatus.FAILED;
      state.error = action.error.message;
    });

    builder.addCase(fetchProjectsByMemberId.pending, (state, action) => {
      state.status = RequestStatus.PENDING;
    });
    builder.addCase(fetchProjectsByMemberId.fulfilled, (state, action) => {
      state.status = RequestStatus.SUCCEEDED;
      // remove the type any when the api is ready
      state.joinedProjects = action.payload as any;
    });
    builder.addCase(fetchProjectsByMemberId.rejected, (state, action) => {
      state.status = RequestStatus.FAILED;
      state.error = action.error.message;
    });
  },
});

export const { resetProjects } = projectsSlice.actions;

export default projectsSlice.reducer;
